export default __webpack_public_path__ + "30aa5dcfcd2a26f3bfa2556c3fb50058.svg";